<template>
  <div :class="['footer-player', 'ml-1', 'hidden-xs-only']" v-if="playerData">
    <iframe title="bandcamp-embedded-player" seamless :src="makePlayerUrl" v-if="$config.bandCampPlayer.use" />
    <on-page-vc-audio-player v-else :controls="controls" max-width="400px" :album="playerData.album" :compact="true" />
  </div>
</template>
<script>
export default {
  name: 'FooterPlayer',
  data () {
    return {
      playerData: null,
      controls: [
        'playpause',
        'title',
        'previous',
        'next',
        'stop'
      ]
    }
  },
  computed: {
    makePlayerUrl () {
      return `https://bandcamp.com/EmbeddedPlayer/album=${this.playerData.album}/artwork=none/size=small/bgcol=${this.bgColor}/linkcol=${this.linkColor}/track=${this.playerData.track}/transparent=true/`
    }
  },
  props: {
    bgColor: {
      type: String,
      default: '212121'
    },
    linkColor: {
      type: String,
      default: '9a64ff'
    }
  },
  created () {
    this.$root.$on('footer-player', (playerData) => {
      this.playerData = playerData
    })
  }
}
</script>
<style>
.footer-player iframe
{
  border: 0;
  width: 320px;
  height: 42px;
  display: block;
}

.footer-player
{
  width: 50%;
}

.footer-player .v-card.v-sheet.theme--dark
{
  background: transparent !important;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/footer-player.vue